import React from 'react';
import { Input, TextArea, DatePicker, DropDown } from 'components/tt-forms/common';
import moment from 'moment';
import {validatable} from 'components/utils';
import { ThanhTra } from 'api';

class ThongTinChung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      ngayRaQuyetDinh: moment().format('DD/MM/YYYY'),
      namThanhTraList: [],
      namThanhTra: '',
      quyetDinhPheDuyetKTTT: '',
      hinhThucKHTTList: [],
      hinhThucKHTT: '',
      nguoiKy: '',
      ghiChu: ''
    }
  }

  componentDidMount() {
    this.getNamThanhTraList();
    this.getHinhThucKeHoachThanhTra();
  }

  getNamThanhTraList() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (res.data) {
        this.state.namThanhTraList = res.data;
        this.state.namThanhTra = res.data[0].giaTri;
      } else {
        this.state.namThanhTraList = [];
      }
      this.setState({...this.state});
      this.props.onChange(this.state);
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data != nextProps.data) {
      this.state.namThanhTra = nextProps.data.namThanhTra;
      this.state.quyetDinhPheDuyetKTTT = nextProps.data.quyetDinhPheDuyetKTTT;
      this.state.ngayRaQuyetDinh = nextProps.data.ngayRaQuyetDinh ? moment(nextProps.data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '';
      this.state.hinhThucKHTT = nextProps.data.chucNangKeHoachThanhTra;
      this.state.nguoiKy = nextProps.data.nguoiKy;
      this.state.ghiChu = nextProps.data.ghiChu;
      this.setState({...this.state});
      this.props.onChange(this.state);
    }
  }

  getHinhThucKeHoachThanhTra() {
    ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(res => {
      if (res.data) {
        this.state.hinhThucKHTTList = res.data;
        this.state.hinhThucKHTT = res.data[0].giaTri;
      } else {
        this.state.hinhThucKHTTList = [];
      }
      this.setState({...this.state});
    });
  }

  onChange(name, e) {
    this.state[name] = e.target.value;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.state[name] = e._d;
    } else {
      this.state[name] = e;
    }
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  render() {
    return (
      <section className='wrap-block'>
        <div className='row pl10 pr10'>
          <h2 className='title-14 col-100 pt20 pl20 pr20 pb15'>1. Thông tin chung</h2>
        </div>
        <div className='row pl25 pr25'>
          <DropDown className='col-input' label='Năm thanh tra' options={this.state.namThanhTraList} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} name='namThanhTra' bindValidator={this} require channel="formTaoDon"/>
          <Input className='col-input' label='Quyết định phê duyệt KHTT'  placeholder='Nhập...' require bindValidator={this} channel="formTaoDon" value={this.state.quyetDinhPheDuyetKTTT} onChange={this.onChange.bind(this, 'quyetDinhPheDuyetKTTT')} name='quyetDinhPheDuyetKTTT' maxLength={255}/>
          <DatePicker className='col-input' label='Ngày phê duyệt' bindValidator={this} require channel="formTaoDon" value={this.state.ngayRaQuyetDinh} onChange={ this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} />
          <DropDown className='col-input' label='Chức năng thanh tra' options={this.state.hinhThucKHTTList} keyName="giaTri" valueName="ten" selectedValue={this.state.hinhThucKHTT} onChange={this.onChange.bind(this, 'hinhThucKHTT')} name='hinhThucKHTT' bindValidator={this} require channel="formTaoDon"/>
          <Input className='col-input' label='Người ký' value={this.state.nguoiKy} onChange={this.onChange.bind(this, 'nguoiKy')} name='nguoiKy' placeholder='Nhập...'/>

          <TextArea className='col-100' label='Tóm tắt kế hoạch' value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} name='ghiChu' rows={3} placeholder='Nhập...' maxLength={1000} />
        </div>
      </section>
    );
  }
}

ThongTinChung.defaultProps = {
  data: {}
}

export default validatable(ThongTinChung);


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/ThongTinChung.jsx